import React from 'react';

function BackIcon(props) {
  return (
    <svg
    width={38}
    height={38}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27.36 20.26a.5.5 0 1 0 0-1v1Zm-15.553-.854a.5.5 0 0 0 0 .708l3.182 3.181a.5.5 0 1 0 .707-.707l-2.829-2.828 2.829-2.828a.5.5 0 0 0-.707-.707l-3.182 3.181Zm15.553-.146h-15.2v1h15.2v-1Z"
      fill={props.color || "#5E5E5E"}
    />
  </svg>
  );
}

export default BackIcon;